// extracted by mini-css-extract-plugin
module.exports = {"content_page__section":"main_faqs--content_page__section","hero_form":"main_faqs--hero_form"};